import { apiPost } from '../../api'

export const update_program = data => {
  return apiPost({
    endpoint: 'programs/update_program',
    data: data
  })
}
